import React from 'react'
import Logo from '../../images/HeroBanner.png'
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const slideIn = {
  visible: { opacity: 1, translateX: 0 },
  hidden: { opacity: 0, translateX: -200 },
};

const HeroBanner = () => {
  const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.3
	  });
	
  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={slideIn}
      transition={{ duration: 0.8, ease: "easeIn" }}
      className="z-30  max-w-[300px] tablet:max-w-[400px] sm:max-w-[500px]  md:max-w-[550px] mb-14 md:mb-[100px] mt-20">
        <img src={Logo} alt="DSC LOGO" />
    </motion.div>
  )
}

export default HeroBanner